import { ShowAlert, error } from "../../common/alert";

export const findLinesWithIndentationDecrease = (markdownArray, targetId) => {
   let startIndex = -1;
   let endIndex = -1;

   // Step 1: Find the starting index of the line with the target ID
   for (let i = 0; i < markdownArray.length; i++) {
      if (markdownArray[i].includes(targetId)) {
         startIndex = i;
         break;
      }
   }

   // If the ID was not found, return an empty array
   if (startIndex === -1) return [];

   // Step 2: Calculate the indentation of the starting line
   const startingLine = markdownArray[startIndex];
   const initialIndentation = startingLine.search(/\S/); // Indentation of the starting line

   // Step 3: Find the end index where indentation decreases or is zero
   for (let i = startIndex + 1; i < markdownArray.length; i++) {
      const currentIndentation = markdownArray[i].search(/\S/); // Get indentation of the current line

      // If indentation is zero or decreases, set the end index and break the loop
      if (currentIndentation <= initialIndentation) {
         endIndex = i;
         break;
      }
   }

   // If endIndex wasn't set, that means we reached the end of the array
   if (endIndex === -1) {
      endIndex = markdownArray.length;
   }
   const arr = markdownArray.slice(startIndex, endIndex);
   const firstElementId = markdownArray[startIndex].slice(-36); // Get the last 32 characters
   const lastElementId = markdownArray[endIndex - 1].slice(-36); // Get the last 32 characters
   const markdownLines = arr.map((line) => line.replace(/\s+\w{8}-\w{4}-\w{4}-\w{4}-\w{12}$/, "")); // Remove the ID at the end
   const markdownText = markdownLines.join("\n");
   // Return the selected lines
   return { markdownText, firstElementId, lastElementId };
};
export const handleCopy = (e, id, arr) => {
   const selectedMarkdown = findLinesWithIndentationDecrease(arr, id);
   const markdownRegex = /([*_~`]|^#{1,6}\s|^\[([^\]]+)\]\([^)]+\))/g;
   let cleanString = selectedMarkdown.markdownText.replace(markdownRegex, "");
   copyContent(cleanString);
   const startElement = document.getElementById(selectedMarkdown.firstElementId);
   const endElement = document.getElementById(selectedMarkdown.lastElementId);
   if (startElement && endElement) {
      let currentElement = startElement;

      // Highlight the start element
      startElement.style.backgroundColor = "#E8F1FF"; // Change to your desired highlight color

      while (currentElement && currentElement !== endElement) {
         currentElement = currentElement?.nextElementSibling;
         if (currentElement) {
            currentElement.style.backgroundColor = "#E8F1FF"; // Change to your desired highlight color
         }
      }
      endElement.style.backgroundColor = "#E8F1FF"; // Change to your desired highlight color
      const scrollableContainer = document.getElementById("scrollbar-notes-transcript"); // Scrollable div
      const element = document.getElementById(selectedMarkdown.firstElementId); // Element inside scrollable div
      const tooltipElement = document.getElementById("tooltipPositionNew"); // Tooltip element

      if (element && scrollableContainer && tooltipElement) {
         const elementRect = element.getBoundingClientRect(); // Element's bounding rectangle
         //  const containerRect = scrollableContainer.getBoundingClientRect(); // Scrollable container's bounding rectangle
         //  const top = elementRect.top - containerRect.top + scrollableContainer.scrollTop;
         const top = elementRect.top + window.scrollY;
         tooltipElement.style.top = `${top - 250}px`;
         tooltipElement.style.display = "block";
         setTimeout(() => {
            tooltipElement.style.display = "none";
         }, 3000); // 3 seconds delay
      }
   }

   setTimeout(() => {
      if (startElement && endElement) {
         let currentElement = startElement;
         startElement.style.backgroundColor = "#f6f6f6"; // Change to your desired highlight color
         while (currentElement && currentElement !== endElement) {
            currentElement = currentElement?.nextElementSibling;
            if (currentElement) {
               currentElement.style.backgroundColor = "#f6f6f6"; // Change to your desired highlight color
            }
         }
         endElement.style.backgroundColor = "#f6f6f6"; // Change to your desired highlight color
      }
   }, 3000);
};

export const copyContent = async (text) => {
   if (typeof text !== "string") return;
   try {
      await navigator.clipboard.writeText(text);
      ShowAlert("Copied to clipboard.");
   } catch (err) {
      ShowAlert("Copy failed. Please try again.", error);
   }
};
export const removeHashAndAsterisk = (text) => {
   if (typeof text !== "string") {
      return "Please provide a valid string.";
   }
   const modifiedText = text.replace(/[#*]/g, "");
   return modifiedText;
};
